import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import {
  hasValidSession,
  getAuthUser,
  clearSession,
  yoneticiRotasiMi,
  GECERLI_KULLANICI_TIPLERI,
  USER_TYPE,
} from "../helpers/auth_client";

/**
 * Korumalı rota sarmalayıcısı.
 *
 * Eskiden yalnızca `localStorage.getItem("authUser")` dolu mu diye bakıyordu;
 * konsoldan elle bir nesne yazan herkes panele girebiliyordu. Artık geçerli
 * (süresi dolmamış) bir token ve tanınan bir kullanıcı tipi aranıyor.
 *
 * Panel müşteri, sürücü/çekici ve yöneticiye açıktır; sayfa içerikleri role göre
 * değişir. Yalnızca yönetime ait sayfalar ayrıca korunur — kenar menüsünde
 * gizli olmaları yetmez, adresi elle yazan da geçememeli.
 *
 * Not: Bu kontrol kullanıcı deneyimi içindir — asıl yetkilendirme API tarafında
 * her istekte yapılır. Buradaki kontrolü aşan biri de veriye ulaşamaz.
 */
const Authmiddleware = (props) => {
  const location = useLocation();

  if (!hasValidSession()) {
    clearSession();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const user = getAuthUser();
  const kullaniciTipi = Number(user?.Users_Type_ID);

  if (!user || !GECERLI_KULLANICI_TIPLERI.includes(kullaniciTipi)) {
    clearSession();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Yönetim sayfasına yetkisiz erişim: oturumu kapatmıyoruz, kullanıcı geçerli —
  // yalnızca kendi ana sayfasına geri gönderiyoruz.
  if (yoneticiRotasiMi(location.pathname) && kullaniciTipi !== USER_TYPE.ADMIN) {
    return <Navigate to="/dashboard" replace />;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Authmiddleware;
